import { render, staticRenderFns } from "./img-upload.vue?vue&type=template&id=130881a3&scoped=true"
import script from "./img-upload.vue?vue&type=script&lang=js"
export * from "./img-upload.vue?vue&type=script&lang=js"
import style0 from "./img-upload.vue?vue&type=style&index=0&id=130881a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130881a3",
  null
  
)

export default component.exports